// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__eqcub","icon":"Breadcrumbs_icon__mbVPT","wrapper":"Breadcrumbs_wrapper__eUZTw","item":"Breadcrumbs_item__Zld4B"};